import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Terms of service</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>
              <strong>Website Terms of Use </strong>
            </p>
            <p>Last Updated: August 14, 2020</p>
            <p>
              Please read the following terms and conditions (the “
              <strong>Terms of Use</strong>”) carefully. These Terms of Use
              govern your access to and use of the website operated by
              Bernicemy, Inc. (the “<strong>Company</strong>”) located at{" "}
              <Link onClick={toTop} to="/">
                Home
              </Link>{" "}
              (“the “<strong>Site</strong>”), any associated Content (as defined
              below) (the Site, together with the Content, are collectively
              referred to as the “<strong>System</strong>”), and the services,
              features, functionality, and offers made available through the
              System (the “<strong>Services</strong>”).
            </p>
            <p>
              <strong>
                By accessing, browsing, downloading, using, or registering to
                receive the System or Services, you acknowledge that you have
                read and understood these Terms of Use and that you accept and
                agree to be bound by them in full. If you do not agree to these
                Terms of Use, do not use any portion of the System or the
                Services.{" "}
              </strong>
            </p>
            <p>
              <strong>Changes to the Terms of Use</strong>
            </p>
            <p>
              We may update or modify these Terms of Use at any time effective
              upon posting the revised Terms of Use, along with the date on
              which it was most recently updated, on the Site. We may give
              notice of such updates and modifications by any means, including
              without limitation, by posting a revised version of these Terms of
              Use on the Site, or providing other notice on the Site (“
              <strong>Notice</strong>”). All Notices will be effectively
              immediately. You should view these Terms of Use often to stay
              informed of any changes that may affect you. Your continued use of
              the System and/or the Services thereafter signifies your
              acceptance to such changes.
            </p>
            <p>
              The version of these Terms of Use posted on our Site on each
              respective date you visit the Site will be the Terms of Use
              applicable to your access and use of the System and Services on
              that date. We reserve the right to terminate these Terms of Use,
              or to refuse, restrict, or discontinue access to the System or use
              of the Services (or any portions, components, or features thereof)
              to you or any other person or entity, for any reason or for no
              reason whatsoever, at any time, without notice or liability.
            </p>
            <p>
              <strong>Ownership of the System and Access License </strong>
            </p>
            <p>
              You understand and agree that Company owns, or has been licensed
              by third parties to use, all right, title, and interest in and to
              the System and the Services, and all information, text, data,
              computer code, music, artwork, databases, graphics, images, sound
              recordings, audio and visual clips, logos, software, and other
              materials contained therein, and the compilation, collection,
              design, selection, and arrangement thereof (collectively, the “
              <strong>Content</strong>”), as well as the design, structure,
              selection, coordination, expression, “look and feel,” and
              arrangement of such Content.
            </p>
            <p>
              You acknowledge that the System and the Services are proprietary
              to Company and are protected by applicable intellectual property
              and other proprietary rights, laws, and treaties of the United
              States and other countries, and that you acquire no ownership
              interest in the System or the Services by accessing and using
              either. For the avoidance of doubt, “Content” does not include any
              Third Party Materials (as defined below) or any features,
              opportunities, or services made available through third party
              websites.
            </p>
            <p>
              Company grants you a personal, non-exclusive, non-transferable,
              revocable, limited license to use the System and the Services
              solely for your personal or internal use and subject to the
              condition that you do not (and do not allow any third party to)
              copy, modify, create a derivative work from, reverse engineer,
              reverse assemble, or otherwise attempt to discover any source
              code, sell, assign, sublicense, grant a security interest in, or
              otherwise transfer any right in or access to the System, the
              Services, or any other Content available via the System or the
              Services. All rights not expressly granted to you in these Terms
              of Use are reserved and retained by Company.
            </p>
            <p>
              <strong>Use of the System and Services</strong>
            </p>
            <p>
              Company reserves the right to do any of the following at any time
              without notice: (i) modify, suspend, or terminate operation of or
              access to the System, the Services, or any portion thereof, for
              any reason; (ii) modify or change the System, the Services, or any
              portion thereof, and any applicable policies or terms; and (iii)
              interrupt the operation of the System, the Services, or any
              portion thereof, as necessary to perform routine or non-routine
              maintenance, perform error correction, or make other changes.
            </p>
            <p>
              You represent and agree that all information that you provide to
              Company in connection with your access to and use of the System
              and the Services is and shall be true, accurate, and complete, to
              the best of your knowledge, ability, and belief.
            </p>
            <p>
              Any use or attempted use of the System and/or the Services (i) for
              any unlawful, unauthorized, fraudulent or malicious purpose; (ii)
              that could damage, disable, overburden, or impair any server, or
              the network(s) connected to any server; (iii) that could interfere
              with any other party's use and enjoyment of the System or the
              Services; (iv) to gain unauthorized access to any other accounts,
              computer systems or networks connected to any server or systems
              through hacking, password mining or any other means; (v) to access
              systems, data or information not intended by Company to be made
              accessible to a user; (vi) to attempt to obtain any materials or
              information through any means not intentionally made available by
              us; or (vii) for any use other than the purpose for which it was
              intended, is prohibited.
            </p>
            <p>
              In addition, in connection with your use of the System and the
              Services, you agree you will not:
            </p>
            <ul>
              <li>
                Upload or transmit any message, information, data, text,
                software or images, or other content that is unlawful, immoral,
                harmful, threatening, abusive, harassing, tortious, defamatory,
                vulgar, obscene, libelous, or otherwise objectionable, or that
                may invade another's right of privacy or publicity;
              </li>
              <li>
                Create a false identity for the purpose of misleading others or
                impersonate any person or entity, including, without limitation,
                any Company representative, or falsely state or otherwise
                misrepresent your affiliation with a person or entity;
              </li>
              <li>
                Upload or transmit any material that you do not have a right to
                reproduce, display or transmit under any law or under
                contractual or fiduciary relationships (such as nondisclosure
                agreements);
              </li>
              <li>
                Upload files that contain viruses, Trojan horses, worms, time
                bombs, cancel-bots, corrupted files, or any other similar
                software or programs that may damage the operation of another's
                computer or property of another;
              </li>
              <li>
                Delete any author attributions, legal notices or proprietary
                designations or labels that you upload to any communication
                feature;
              </li>
              <li>
                Use any of the System’s or Services’ communication features in a
                manner that adversely affects the availability of its resources
                to other users (e.g., excessive shouting, use of all caps, or
                flooding continuous posting of repetitive text);
              </li>
              <li>
                Upload or transmit any unsolicited advertising, promotional
                materials, “junk mail”, “spam”, “chain letters”, “pyramid
                schemes” or any other form of solicitation, commercial or
                otherwise;
              </li>
              <li>
                Violate any applicable local, state, national or international
                law;
              </li>
              <li>
                Upload or transmit any material that infringes any patent,
                trademark, service mark, trade secret, copyright or other
                proprietary rights of any party;
              </li>
              <li>
                Delete or revise any material posted by any other person or
                entity;
              </li>
              <li>
                Probe, scan, test the vulnerability of or breach the
                authentication measures of, the System or any related networks
                or systems;
              </li>
              <li>
                Register, subscribe, attempt to register, attempt to subscribe,
                unsubscribe, or attempt to unsubscribe, any party for any
                products or services if you are not expressly authorized by such
                party to do so;
              </li>
              <li>
                Harvest or otherwise collect information about others, including
                e-mail addresses;
              </li>
              <li>
                Use any modified versions of the System or the Services, for any
                reason whatsoever, without the express written consent of
                Company;
              </li>
              <li>
                Attempt to gain any unauthorized access to the System, the
                Services or any of its associated Content, including computer
                systems, software, or networks; or
              </li>
              <li>
                Use any robot, spider, scraper, or other automated or manual
                means to access the System or the Services, or copy any Content
                or information thereon.
              </li>
            </ul>
            <p>
              Company reserves the right to take whatever lawful actions it may
              deem appropriate in response to actual or suspected violations of
              these Terms of Use, including, without limitation, the suspension
              or termination of your access and/or account. Company may
              cooperate with legal authorities and/or third parties in the
              investigation of any suspected or alleged crime or civil wrong.
              Company reserves the right at all times to disclose any
              information as Company deems necessary to satisfy any applicable
              law, regulation, legal process or governmental request, or to
              edit, refuse to post or to remove any information or materials, in
              whole or in part, in Company’s sole discretion.
            </p>
            <p>
              <strong>Accounts, Passwords, and Security</strong>
            </p>
            <p>
              In order to utilize certain Services, you may need to set up an
              account (including establishing a login ID and password). You are
              entirely responsible for maintaining the confidentiality of your
              account information, including your login ID and password, and for
              any and all activity that occurs under your account or login ID.
              You agree to notify Company immediately upon learning of any
              unauthorized use of your account, login ID, or password or any
              other unauthorized access or breach of security. However, you may
              be held liable for losses incurred by Company or any other person
              or entity due to another person using your account, login ID, or
              password.
            </p>
            <p>
              You may not use any other user’s account, login ID, or password at
              any time without the express permission and consent of the holder
              of that account, login ID, or password. You may not transfer or
              assign your account. Company cannot and will not be liable for any
              loss or damage arising from your failure to comply with these
              obligations. If you are under 18, you may use the Services only
              with involvement of a parent or guardian. We reserve the right to
              suspend or terminate your account in the event that you breach any
              of these Terms of Use.
            </p>
            <p>
              <strong>Submissions </strong>
            </p>
            <p>
              Any information, communications, or material of any type or nature
              that you submit to or post on the System (or to any of our pages
              on a social media platform or other website) by e-mail, posting,
              messaging, uploading, downloading, or otherwise (collectively, a “
              <strong>Submission</strong>”) is done at your own risk and without
              any expectation of privacy. You are fully responsible for all
              Submissions, which must comply with these Terms of Use. You hereby
              agree that by inputting/submitting such Submissions, you grant
              Company a nonexclusive, unrestricted, irrevocable, worldwide,
              sub-licenseable, transferable, perpetual, unlimited, assignable,
              fully paid up and royalty-free right to copy, display, edit,
              publish, prepare derivative works of, distribute, process,
              analyze, use and commercialize, in any media known or hereinafter
              developed, such Submissions (or any content or materials contained
              therein). You represent and warrant that you have the full legal
              right to so use such Submissions and that they, and any content or
              material contained therein, are not confidential or proprietary to
              any third party, nor are you using it in violation of any law or
              contractual restriction.
            </p>
            <p>
              Company neither actively monitors general use of the System, nor
              exercises editorial control over any Submissions. However, Company
              does reserve the right to monitor such Submissions or other use at
              any time as it deems appropriate and to remove any materials that,
              in Company’s sole discretion, may be illegal, may subject Company
              to liability, may violate these Terms of Use, or are, in the sole
              discretion of Company, inconsistent with Company purpose for the
              System.
            </p>
            <p>
              <strong>Electronic Communications</strong>
            </p>
            <p>
              When you use the System and/or Services or send e-mails to us, you
              are communicating with us electronically. You consent to receive
              communications from us electronically. We will communicate with
              you by e-mail or by posting notices on the System and/or Services.
              You agree that all agreements, notices, disclosures, and other
              communications that we provide to you electronically satisfy any
              legal requirement that such communications be in writing. You
              further agree that any notices provided by us electronically are
              deemed to be given and received on the date we transmit any such
              electronic communication as described in these Terms of Use.
            </p>
            <p>
              <strong>Disclaimers </strong>
            </p>
            <p>
              The information and materials available through the System and the
              Services are for informational and educational purposes only. You
              acknowledge and agree that your use of the System and Services is
              at your own risk.
            </p>
            <p>
              The information, software, CONTENT, SERVICES, or materials
              available from or provided on the System or via the Services, ARE
              provided “AS IS” and “AS AVAILABLE”, without warranties or
              guaranties of any kind, either expressed or implied, including,
              but not limited to, the implied warranties of merchantability,
              title, fitness for a particular purpose, non-infringement, and any
              warranties implied by a course of performance, course of dealing,
              or usage of trade.
            </p>
            <p>
              Company AND/OR OUR THIRD PARTY SUPPLIERS OR LICENSORS DO NOT
              REPRESENT, WARRANT OR COVENANT THAT THE SYSTEM AND THE SERVICES
              ARE OR WILL BE ACCURATE, CURRENT, COMPLETE, FREE OF TECHNICAL AND
              TYPOGRAPHICAL ERRORS, secure, RELIABLE, OR APPROPRIATE FOR ANY
              PARTICULAR USE TO WHICH YOU OR ANY THIRD PARTY MAY CHOOSE TO PUT
              THEM, THAT THEY ARE OR WILL BE AVAILABLE ON AN UNINTERRUPTED AND
              ERROR-FREE BASIS, THAT DEFECTS WILL BE CORRECTED, OR THAT THE
              SYSTEM AND SERVICES ARE FREE OF VIRUSES OR OTHER DISABLING DEVICES
              OR HARMFUL COMPONENTS. Company PERIODICALLY AMENDS, CHANGES, ADDS,
              DELETES, UPDATES, OR ALTERS THE SYSTEM AND THE SERVICES WITHOUT
              NOTICE. FURTHER, Company ASSUMES NO LIABILITY OR RESPONSIBILITY
              FOR ANY ERRORS OR OMISSIONS IN THE CONTENT OF THE SYSTEM OR THE
              SERVICES. Company SPECIFICALLY DISCLAIMS ANY DUTY TO UPDATE THE
              CONTENT, OR ANY OTHER INFORMATION ON THE SYSTEM OR THE SERVICES.
            </p>
            <p>
              <strong>Limitation of Liability</strong>
            </p>
            <p>
              IN NO EVENT SHALL Company, ITS CONTRACTORS, SUPPLIERS, CONTENT
              PROVIDERS, OR THE OFFICERS, DIRECTORS, EMPLOYEES, REPRESENTATIVES,
              AND AGENTS OF EACH OF THE FOREGOING, BE LIABLE TO YOU OR ANY OTHER
              THIRD PARTY FOR ANY LOSS, COST, DAMAGE, OR OTHER INJURY, WHETHER
              IN CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY, OR OTHERWISE,
              ARISING OUT OF OR IN CONNECTION WITH: (A) THE USE OF, OR RELIANCE
              ON, THE SYSTEM AND/OR SERVICES; (B) the security of the system
              AND/or the services; (c) THE USE, COPYING, OR DISPLAY OF THE
              SYSTEM AND/OR THE SERVICES OR THE TRANSMISSION OF INFORMATION TO
              OR FROM THE SYSTEM OVER THE INTERNET; (d) Company’S PERFORMANCE
              OF, OR FAILURE TO PERFORM, ITS OBLIGATIONS IN CONNECTION WITH
              THESE TERMS OF USE AND THE SERVICES; (e) ANY DEFAMATORY,
              OFFENSIVE, OR ILLEGAL CONDUCT BY YOU, OTHER USERS OF THE SYSTEM OR
              THE SERVICES, OR OTHER THIRD PARTIES; OR (F) THE AVAILABILITY,
              RELIABILITY, ACCURACY, TIMELINESS, OR QUALITY OF THE SERVICES.
              UNDER NO CIRCUMSTANCES SHALL Company, OR ITS CONTRACTORS,
              SUPPLIERS, CONTENT PROVIDERS, OR THE OFFICERS, DIRECTORS,
              EMPLOYEES AND AGENTS OF EACH OF THE FOREGOING, BE LIABLE TO YOU OR
              ANY OTHER THIRD PARTY FOR ANY INDIRECT, CONSEQUENTIAL, INCIDENTAL,
              PUNITIVE, SPECIAL, OR SIMILAR DAMAGES OR COSTS (INCLUDING, BUT NOT
              LIMITED TO, LOST PROFITS OR DATA, LOSS OF GOODWILL, LOSS OF OR
              DAMAGE TO PROPERTY, LOSS OF USE, BUSINESS INTERRUPTION, AND CLAIMS
              OF THIRD PARTIES) ARISING OUT OF OR IN CONNECTION WITH THESE TERMS
              OF USE, THE SYSTEM, THE SERVICES, OR ANYTHING DESCRIBED IN THE
              FOREGOING CLAUSES (A) THROUGH (F) OF THIS PARAGRAPH, OR ANY OTHER
              CAUSE BEYOND THE CONTROL OF Company, EVEN IF Company WAS ADVISED,
              KNEW, OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES OR
              COSTS. IN A JURISDICTION THAT DOES NOT ALLOW THE EXCLUSION OR
              LIMITATION OF LIABILITY FOR CERTAIN DAMAGES, THE AGGREGATE
              LIABILITY OF Company AND ITS CONTRACTORS, SUPPLIERS, CONTENT
              PROVIDERS, AND THE OFFICERS, DIRECTORS, EMPLOYEES,
              REPRESENTATIVES, AND AGENTS OF EACH OF THE FOREGOING, SHALL BE
              LIMITED IN ACCORDANCE WITH THESE TERMS OF USE TO THE FULLEST
              EXTENT PERMITTED BY LAW.
            </p>
            <p>
              WITHOUT LIMITING ANY OF THE FOREGOING, IF Company, ITS
              CONTRACTORS, SUPPLIERS, CONTENT PROVIDERS, OR ANY OF THE OFFICERS,
              DIRECTORS, EMPLOYEES, REPRESENTATIVES, OR AGENTS OF ANY OF THE
              FOREGOING, IS FOUND LIABLE TO YOU OR TO ANY THIRD PARTY AS A
              RESULT OF ANY CLAIMS OR OTHER MATTERS ARISING UNDER OR IN
              CONNECTION WITH THESE TERMS OF USE, THE SYSTEM, OR THE SERVICES,
              Company AND SUCH PARTIES’ CUMULATIVE, AGGREGATE, AND MAXIMUM
              LIABILITY FOR ALL SUCH CLAIMS AND OTHER MATTERS IN ANY CALENDAR
              YEAR SHALL NOT EXCEED USD $100.
            </p>
            <p>
              <strong>Indemnification</strong>
            </p>
            <p>
              You agree to indemnify, defend and hold Company harmless from and
              against all claims, demands, suits or other proceedings, and all
              resulting loss, damage, liability, cost, and expense (including
              attorneys' fees), brought by any third party in connection with or
              arising out of content, data, or information that you submit, post
              to, or transmit through the System or Services, your access to and
              use of the System and/or Services, your violation of these Terms
              of Use, your violation of any applicable law, regulation or code,
              or your violation of any rights of another. We reserve, and you
              grant to us, the right to assume exclusive defense and control of
              any matter subject to indemnification by you hereunder. All rights
              and duties of indemnification that are set forth herein shall
              survive termination of these Terms of Use.
            </p>
            <p>
              <strong>Links to Other Websites</strong>
            </p>
            <p>
              For your convenience, certain hyperlinks may be provided on the
              System and Services that link to other websites or social media
              platforms which are not under the control of Company (the “Linked
              Websites”). Company does not endorse or sponsor any Linked
              Websites and is not responsible for the availability, accuracy,
              content, or any other aspect of the Linked Websites. Company
              disclaims all liability for such websites, for all access to and
              use thereof, and for use of the links to such websites. We also
              disclaim all liability, and make no representations or warranties,
              with respect to any products or services made available, sold, or
              provided to you by any third party. Your use of Linked Websites
              and any purchases of products or services from such Linked
              Websites are subject to the terms and conditions of such other
              websites. You agree that you will bring no suit or claim against
              Company arising from or based upon any such use of any Linked
              Websites. Hyperlinks to such Linked Websites on the System and
              Services do not imply that: (a) Company is affiliated or
              associated with any Linked Website; (b) Company is legally
              authorized to use any trademark, trade name, logo, or copyright
              symbol displayed in connection with or accessible through such
              links; or (c) any Linked Site is authorized to use any trademark,
              trade name, logo, or copyright symbol of Company.
            </p>
            <p>
              <strong>Links to the Websites</strong>
            </p>
            <p>
              Neither you nor any other website may link to the Site without the
              permission of Company. In any event, without our express, prior,
              written permission, it is expressly prohibited to: (a) “deep link”
              to any page of the Site other than the home page; (b) “frame” the
              Site or any Content or otherwise cause the Site or any Content to
              appear in a window with any other material that does not
              constitute Content; (c) cause the hyperlink to the Site, or the
              Site or any Content, to be displayed in any way that is
              disparaging to Company or any entity that is affiliated or
              associated with Company; or (d) otherwise imply or state that any
              type of relationship or special arrangements exist with Company
              and any other entity. You agree that you will promptly remove any
              hyperlink to the Site upon the written request of Company. In no
              event will you use any logo or trademark of Company as a hyperlink
              “button”, or in any other manner, without Company’s express
              written consent.
            </p>
            <p>
              <strong>Disclaimer of Third Party Information</strong>
            </p>
            <p>
              To the extent that any information, material, or functionality on
              the System and Services is provided by third party content
              providers (“
              <strong>Third Party Materials</strong>”), Company has no editorial
              control or responsibility over such Third Party Materials.
              Therefore, any opinions, statements, products, services or other
              Third Party Materials are those of the applicable third party.
              Company does not represent or endorse the accuracy or reliability
              of any opinion, statement or other information provided by any
              third party (including any Submissions), or represent or warrant
              that your use of any Third Party Materials will not infringe
              rights of third parties not owned by or affiliated with Company.
            </p>
            <p>
              <strong>General</strong>
            </p>
            <p>
              These Terms of Use and any applicable promotions terms (as each
              may be revised and amended from time to time according to their
              respective terms) collectively constitute the entire agreement
              with respect to your access to and use of the System and the
              Services. You agree that you shall not contest the admissibility
              or enforceability of Company’s copy of these Terms of Use in
              connection with any action or proceeding arising out of or
              relating to these Terms of Use. Except as expressly provided for
              herein, these Terms of Use do not confer any rights, remedies, or
              benefits upon any person or entity other than you and Company.
              Company may assign its rights and duties under these Terms of Use
              at any time to any third party without notice. You may not assign
              these Terms of Use without the prior written consent of Company.
              These Terms of Use shall be binding on and inure to the benefit of
              the parties hereto and their respective successors and assigns.
              You are responsible for complying with any and all laws of the
              jurisdiction from which you are accessing the System and using the
              Services and any other jurisdiction whose laws apply to you or
              your actions. To the extent any portion of these Terms of Use
              shall be determined to be unenforceable by a court of competent
              jurisdiction, such portion will be modified by the court solely to
              the extent necessary to cause such portion to be enforceable, and
              these Terms of Use as so modified will remain in full force and
              effect. Any waiver of any provisions contained in these Terms of
              Use by Company shall not be deemed to be a waiver of any other
              right, term, or provision of these Terms of Use. Any rights not
              expressly granted herein are reserved. Neither these Terms of Use,
              nor any of the Services, create any partnership, joint venture,
              employment, or other agency relationship between Company and you.
              You may not enter into any contract on our behalf or bind us in
              any way.
            </p>
            <p>
              You agree that any violation, or threatened violation, by you of
              these Terms of Use, or the referenced Privacy Policy, constitutes
              an unlawful and unfair business practice that will cause us
              irreparable and unquantifiable harm. You also agree that monetary
              damages would be inadequate for such harm and consent to our
              obtaining any injunctive or equitable relief that we deem
              necessary or appropriate. These remedies are in addition to any
              other remedies we may have at law or in equity.
            </p>
            <p>
              <strong>Governing Law/Jurisdiction/Claims Limitation</strong>
            </p>
            <p>
              These Terms of Use shall be governed by and construed under the
              laws of the State of Alabama , without regard to conflicts of
              laws, principles or rules. Any legal action brought by you that
              arises out of or relates to these Terms of Use or your access to
              and use of the System or the Services must be commenced within one
              year after the cause of action arises. You hereby expressly
              consent and irrevocably submit to the exclusive jurisdiction of
              the state and federal courts sitting in Alabama for resolution of
              any matters related to interpretation, construction, or
              enforcement of these Terms of Use or otherwise in connection with
              these Terms of Use or otherwise related to or in connection with
              your access to and use of the System or the Services. You further
              expressly waive any claim that venue is improper for any reason in
              these courts.
            </p>
            <p>
              <strong>Contact Us</strong>
            </p>
            <p>
              Company welcomes any comments or questions you may have regarding
              these Terms of Use, the System, and/or the Services. Please
              contact us with your comments or questions:
            </p>
            Bernicemy, Inc. <br />
            114 North Court Street <br />
            Florence, AL&nbsp; 35630 <br />
            USA <br />
            &nbsp; <br />
            <a href="mailto:shop@bernicemy.blog">shop@bernicemy.blog</a> <br />
            1-877-757-3934
          </div>
        </div>
      </div>

      <Footer />
    </body>
  );
}

export default Terms;
